import { ProjectPublishingStage, ReviewProject } from '@platform/client/schemas';
import {
  OrganizationProfileLink,
  ProfileItem,
  ProfileItemLong,
  ProfileSection,
  ProfileTabContainer,
  ProfileValueColors,
} from '../../components/ProfileComponents';
import { formatDateStr } from '../../../dashboard/my-projects/utils';
import { dateToDaysAgoString } from '../../../util/DateHelpers';

export const DetailsTabContent = ({ projectData }: { projectData?: ReviewProject }) => {
  return (
    <ProfileTabContainer>
      <ProfileSection>
        <OrganizationProfileLink
          organizationId={projectData?.organizationId}
          organizationName={projectData?.organizationName}
        />
        <ProfileItem label='Role' value={projectData?.roleType} />
        <ProfileItem label='Delivery Type' value={projectData?.deliveryType} />
        <PublishingStageItem
          publishingStage={projectData?.publishingStage}
          publishingStageDate={projectData?.publishingStageDate}
        />
        <ProfileItem label='Workload' value={projectData?.workload} />
        <ProfileItem
          label='Status Date'
          value={
            projectData?.publishingStageDate ? formatDateStr(projectData.publishingStageDate) : ''
          }
        />
        <ProfileItem label='Open to Team' value={projectData?.openToTeam ? 'Yes' : 'No'} />
        <ProfileItem
          label='Start Date'
          value={projectData?.startDate ? formatDateStr(projectData.startDate) : ''}
        />
        <ProfileItem label='Business Type' value={projectData?.businessType} />
        <ProfileItem
          label='End Date'
          value={projectData?.endDate ? formatDateStr(projectData.endDate) : ''}
        />
      </ProfileSection>
      <ProfileSection columns={1}>
        <ProfileItem label='Timezone' value={projectData?.timezone} />
        <ProfileItemLong label='Languages' value={projectData?.language} />
        <ProfileItemLong label='Skills' value={projectData?.expertises} />
        <ProfileItemLong label='Description' value={projectData?.description} />
        <ProfileItemLong label='Goals' value={projectData?.goals} />
      </ProfileSection>
    </ProfileTabContainer>
  );
};

const PublishingStageItem = ({
  publishingStage,
  publishingStageDate,
}: {
  publishingStage?: ProjectPublishingStage;
  publishingStageDate?: string;
}) => {
  let value = '';
  let color: ProfileValueColors = 'default';
  if (publishingStage) {
    value = publishingStage;
    if (publishingStage === 'published') {
      color = 'success';
    } else if (
      publishingStageDate &&
      (publishingStage === 'review' || publishingStage === 'revision_requested')
    ) {
      value += ` (${dateToDaysAgoString(publishingStageDate)})`;
      color = 'warning';
    }
  }
  return <ProfileItem label='Application Status' value={value} color={color} />;
};
